/* eslint-disable react/no-array-index-key */
import React from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
// import ranker1 from '../../../public/assets/ranker1.png';

function RankHoldersCards({ secName, rankerData }) {
  return (
    <div className="">
      <h3 className="font-semibold text-black line-clamp-2 lg:mb-5 mb-4 lg:text-lg text-base">{secName}</h3>
      <div className="flex gap-4 lg:w-full w-[90%]">
        {rankerData.map((profile, index) => (
          <div
            key={index}
            className="bg-white shadow-[2px_2px_14px_0px_#E4F5FF] lg:rounded-lg border-[#DBF2FF] border lg:border-0 rounded-md overflow-hidden flex flex-flexAuto w-[267px] lg:w-[428px]  lg:px-4 px-3 lg:pt-5 pt-3 lg:gap-6 gap-4"
          >
            {/* Profile Image */}
            <div className="lg:w-36 lg:h-[139px] w-[88px] aspect-[121/135] rounded-tl-full rounded-tr-full overflow-hidden bg-[linear-gradient(180deg,#9BCCFF_0%,#FFFFFF_111.46%)]">
              <Image src={profile?.image} alt={profile?.name} width={192} height={192} className="aspect-[121/135 object-cover w-full h-full lg:h-auto" />

            </div>

            {/* Profile Info */}
            <div className="flex flex-col justify-center  md:text-left pb-4">
              <h2 className="lg:text-lg text-sm font-semibold text-black pb-2">
                {profile.name}
              </h2>
              <p className="lg:text-base text-xs text-darknight pb-2">
                {profile.rank}
              </p>
              <div className="space-y-1">
                {profile?.coursesPurchased.map((program, idx) => (
                  <p key={idx} className="lg:text-sm text-[10px] font-light text-darknight">
                    {program}
                  </p>
                ))}
              </div>
            </div>
          </div>

        ))}
      </div>
    </div>
  );
}

RankHoldersCards.propTypes = {
  secName: PropTypes.any,
  rankerData: PropTypes.any,
};

export default RankHoldersCards;
